function calcFov(inFov, ar) {
    return Math.atan(Math.tan(inFov * THREE.Math.DEG2RAD * 0.5) * ar) * THREE.Math.RAD2DEG * 2;
}

export default calcFov;
export { calcFov };